export const ingredientsList = [
    { value: "apple", label: "Apple" },
    { value: "ash gourd", label: "Ash Gourd" },
    { value: "beet root", label: "Beet Root" },
    { value: "bitter gourd", label: "Bitter Gourd" },
    { value: "bottle gourd", label: "Bottle Gourd" },
    { value: "brinjal", label: "Brinjal" },
    { value: "broccoli", label: "Broccoli" },
    { value: "cabbage", label: "Cabbage" },
    { value: "capsicum", label: "Capsicum" },
    { value: "carrot", label: "Carrot" },
    { value: "cauliflower", label: "Cauliflower" },
    { value: "Chicken", label: "Chicken" },
    { value: "Coriender", label: "Coriender" },
    { value: "corn", label: "Corn" },
    { value: "Cottage Cheese", label: "Cottage Cheese" },
    { value: "cucumber", label: "Cucumber" },
    { value: "Egg", label: "Egg" },
    { value: "Elephant Yum", label: "Elephant Yum" },
    { value: "Fish", label: "Fish" },
    { value: "garlic", label: "Garlic" },
    { value: "Ginger", label: "Ginger" },
    { value: "Green Onion", label: "Green Onion" },
    { value: "Kohlrabi", label: "Kohl Rabi" },
    { value: "lady finger", label: "Lady Finger" },
    { value: "Lemon", label: "Lemon" },
    { value: "Lettuce", label: "Lettuce" },
    { value: "Milk", label: "Milk" },
    { value: "Mint", label: "Mint" },
    { value: "mushroom", label: "Mushroom" },
    { value: "onion", label: "Onion" },
    { value: "Papaya", label: "Papaya" },
    { value: "peas", label: "Peas" },
    { value: "potato", label: "Potato" },
    { value: "pumpkin", label: "Pumpkin" },
    { value: "Raddish", label: "Raddish" },
    { value: "Raw Banana", label: "Banana" },
    { value: "Raw Jackfruit", label: "Jackfruit" },
    { value: "spinach", label: "Spinach" },
    { value: "tomato", label: "Tomato" },
    { value: "Turnip", label: "Turnip" },
];

export const dietList = [
    { value: "vegan", label: "Vegan" },
    { value: "dairy-free", label: "Dairy Free" },
    { value: "gluten-free", label: "Gluten Free" },
];

